import React, { useState } from 'react';

function Questioncontent3({ onNext, onBack }) {
  const [selectAnoymouslyradio, setSelectAnoymouslyradio] = useState('');
  const [error, setError] = useState(''); // Error message
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  // Handle radio button change
  const handleRadioChange = (event) => {
    setSelectAnoymouslyradio(event.target.value);
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();


    if (!selectAnoymouslyradio) {
      setError('Please select an option before proceeding.');
      return;
    } else {
      setError('');
    }

    setLoading(true);
    setApiError('');

    const data = {
      selectAnoymouslyradio
    }

    onNext({ data });
  };

  const sendAnonymously = [
    {
      id: 0,
      title: 'Yes',
    },
    {
      id: 1,
      title: 'No',
    },
  ];

  return (
    <div className="r-content">
      <p className="content-text">
        You can submit a report or question anonymously. Anonymous reports or
        questions will be handled in the same way as those with disclosed
        reporters. If you decide to disclose your information, this will enable
        a more productive and efficient handling of the report or question.
        Your information will always be treated confidentially. In both cases,
        you will be given a username and password that will allow you to access
        your online mailbox and securely track your report or question and
        continue communication.
      </p>
      <br />
      <div className="content-text">
        Are you ready to share your personal information?
      </div>
      <form method="POST" onSubmit={handleSubmit}>
        {error && (
          <div className="error" style={{ color: 'red', marginTop: '10px' }}>
            {error}
          </div>
        )}
        {apiError && (
          <div className="error" style={{ color: 'red', marginTop: '10px' }}>
            {apiError}
          </div>
        )}
        <div className="abusetestlist">
          {sendAnonymously.map((anonymouslydata) => (
            <label className="reportradiobutton" key={anonymouslydata.id}>
              <p className="checkbox-label" htmlFor={`abuse-${anonymouslydata.id}`}>{anonymouslydata.title}</p>
              <input
                className="custom-radio"
                type="radio"
                id={`abuse-${anonymouslydata.id}`}
                name="abuseType"
                value={anonymouslydata.title}
                checked={selectAnoymouslyradio === anonymouslydata.title}
                onChange={handleRadioChange}
              />
            </label>
          ))}
        </div>
        <div className="back-next">
          <button type="button" className="Backbtn" onClick={onBack}>
            Back
          </button>
          <button type="submit" className="Nextbtn" disabled={loading}>
            {loading ? 'Submitting...' : 'Next'}
          </button>
        </div>
      </form >
    </div >
  );
}

export default Questioncontent3;
